import React, { useState, useRef, useEffect } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Select from "@mui/material/Select";
import { Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { inputLabelClasses } from "@mui/material/InputLabel";
import CircleIcon from "@mui/icons-material/Circle";
import { ClickAwayListener } from "@mui/base/ClickAwayListener";
import ClearIcon from "@mui/icons-material/Clear";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IconButton from "@mui/material/IconButton";
import "./style.css";

const SelectField = ({
    id,
    label,
    value,
    selectOptions,
    type,
    isMultiselect,
    onChange,
    selectedItems,
    enableFavourite,
    ...rest
}) => {
    const [selectedValues, setSelectedValues] = useState(selectedItems);
    const [open, setOpen] = React.useState(false);
    const selectRef = useRef();

    const handleChange = (event) => {
        let newValue = event.target.value;
        setSelectedValues(newValue);
        onChange({ id: id, value: newValue });
        if (!isMultiselect) {
            setOpen(false);
        }
    };

    const handleClick = (event) => {
        event.stopPropagation();
        if (event.target.selected && !isMultiselect) {
            setSelectedValues(undefined);
            onChange({ id: id, value: "" });
        }
    };

    const handleCircleIcon = (value) => {
        if (selectedValues === value && !isMultiselect) {
            setSelectedValues(undefined);
            onChange({ id: id, value: "" });
        }
    };

    const handleOpen = (event) => {
        setOpen(true);
    };

    const handleClickAway = () => {
        setOpen(false);
        //selectRef?.current?.click();
    };

    const handleClear = () => {
        setSelectedValues([]);
        onChange({ id: id, value: "" });
        setOpen(false);
    };
    return (
        <>
            {type === "outlined" ? (
                <div>
                    <FormControl fullWidth sx={{ mb: 1, "& .MuiSelect-select:focus": { backgroundColor: "black" } }}>
                        <FormLabel htmlFor="my-input" sx={{ color: "#00000" }}>
                            <Typography gutterBottom variant="subtitle1">
                                {open ? "" : label}
                            </Typography>
                        </FormLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedValues}
                            MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                            sx={{ fontborderBottom: 2 }}>
                            <MenuItem value="">Select</MenuItem>
                            {selectOptions.map((item) => (
                                <MenuItem key={item.id} value={item.value}>
                                    <Checkbox checked={item.indexOf(id) > -1} />
                                    {item.value}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            ) : (
                <div>
                    <ClickAwayListener onClickAway={handleClickAway}>
                        <FormControl
                            fullWidth
                            variant="standard"
                            sx={{
                                m: 1,
                            }}>
                            <InputLabel
                                sx={{
                                    fontSize: "0.85rem",
                                    mt: 0,
                                    ml: 0,
                                    color: "#000",
                                    // [`&.${inputLabelClasses.focused}`]: {
                                    //     // set the color of the label when shrinked (usually when the TextField is focused)
                                    //     color: "black",
                                    // },
                                }}
                                id="demo-simple-select-standard-label"
                                shrink={false}>
                                {selectedValues?.length > 0 ? "" : label}
                            </InputLabel>

                            <Select
                                open={open}
                                ref={selectRef}
                                multiple={isMultiselect}
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={selectedValues}
                                onClick={handleClick}
                                onChange={handleChange}
                                label={label}
                                MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                                {...rest}
                                sx={{ fontSize: "0.85rem", borderBottom: 2 }}
                                disableUnderline
                                renderValue={(selected) =>
                                    isMultiselect
                                        ? selected?.length > 1
                                            ? selected[0] + "+" + (selected?.length - 1)
                                            : selected
                                        : selected
                                }
                                IconComponent={(_props) => {
                                    return selectedValues?.length > 0 ? (
                                        <>
                                            <IconButton id="basic-menu" onClick={handleClear}>
                                                <ClearIcon sx={{ fontSize: 12 }} />
                                            </IconButton>
                                        </>
                                    ) : (
                                        <ExpandMoreIcon sx={{ fontSize: 12 }} />
                                    );
                                }}
                                /*renderValue={(selected) => (isMultiselect ? label : label)}*/
                                onOpen={handleOpen}>
                                {selectOptions.map((item) => (
                                    <MenuItem
                                        sx={{ color: "#000", fontSize: "0.85rem", px: 1 }}
                                        key={item.id}
                                        value={item.key}>
                                        {selectedValues?.indexOf(item.key) > -1 ? (
                                            <CircleIcon
                                                sx={{ mr: 1, fontSize: 8, color: "#000" }}
                                                onClick={() => handleCircleIcon(item.key)}
                                            />
                                        ) : (
                                            <CircleIcon sx={{ mr: 2, fontSize: 0, color: "white" }} />
                                        )}
                                        {item.value}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </ClickAwayListener>
                </div>
            )}
        </>
    );
};
export { SelectField };
